const initialState = {
    inUse: 0
};

export default initialState;
